//colorSlice.js
import { createSlice } from '@reduxjs/toolkit';  
  
export const colorSlice = createSlice({  
  name: 'color',  
  initialState: {
    value: '#0d8c6d', 
  },  
  reducers: {  
    setColor: (state, action) => {  
      state.value = action.payload;  
    },  
  },  
});  
  
export const { setColor } = colorSlice.actions;  
  
export default colorSlice.reducer;